import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import LazyLoad from 'react-lazyload';

// STYLES
import { Container } from './styles';

const ServiceLogoCard = ({ src, title, className }) => {
  return (
    <Container className={clsx('service-logo-card', className)}>
      <LazyLoad height={80} once>
        <img src={src} alt={title} />
      </LazyLoad>
    </Container>
  );
};

ServiceLogoCard.defaultProps = {
  className: '',
};

ServiceLogoCard.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default React.memo(ServiceLogoCard);
